import styled from 'styled-components'

export const CategoryTitle = styled.h3`
  display: inline;
`

export const ButtonAddChat = styled.button`
  border-radius: 50%;
  outline: none;
  border: none;
  cursor: pointer;
`
export const ChatList = styled.ul`
  list-style: none;
  padding-left: 26px;
`
export const Message = styled.p`
  color: #e4f2e7;
`
